import { useCallback } from "react";

import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useRestMutation from "@/remoteState/useRestMutation";

export const useBookmarkContentDelete = () => {
  const deleteBookmarkContent = useCallback((id) => {
    return new Request(`${MONOLITH_ORIGIN}/api/v3/content-bookmark/${id}/`, {
      method: "DELETE",
    });
  }, []);

  return useRestMutation(deleteBookmarkContent);
};

export default useBookmarkContentDelete;
